var _path, _path2, _path3, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOrders(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.333 16L16 24 2.667 16",
    stroke: "url(#orders_svg__paint0_linear)",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.333 21.334l-13.333 8-13.333-8",
    stroke: "url(#orders_svg__paint1_linear)",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.333 10.667l-13.333 8-13.333-8 13.333-8 13.333 8z",
    stroke: "url(#orders_svg__paint2_linear)",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "orders_svg__paint0_linear",
    x1: 2.667,
    y1: 24,
    x2: 18.298,
    y2: 6.271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D9CAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#779AF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "orders_svg__paint1_linear",
    x1: 2.667,
    y1: 29.334,
    x2: 18.298,
    y2: 11.604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D9CAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#779AF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "orders_svg__paint2_linear",
    x1: 2.667,
    y1: 18.667,
    x2: 29.709,
    y2: 3.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D9CAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#779AF7"
  })))));
}

export default SvgOrders;